import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";

dayjs.extend(isToday);
dayjs.extend(isYesterday);

export function formatActivityDate(date: string) {
  const day = dayjs(date);

  if (day.isToday()) {
    return "Today" + `, ${day.format("h:mm A")}`;
  }

  if (day.isYesterday()) {
    return "Yesterday" + `, ${day.format("h:mm A")}`;
  }

  if (day.isBefore(dayjs(), "year")) {
    return day.format("MMM D, YYYY, h:mm A");
  }

  return day.format("MMM D, h:mm A");
}

export function formatDate(date: string, options?: Intl.DateTimeFormatOptions) {
  options = options || {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };
  try {
    return Intl.DateTimeFormat(Office.context.displayLanguage, options).format(new Date(date));
  } catch (error) {
    console.error("Error formatting date:", error);
    return String(date);
  }
}
